import {AccountInfo} from '../api/AccountApi';
import {PresenceType} from '../../bridges/socialBridge';
import {LinkResponse} from '../../bridges/accountLinkingBridge';

export enum AccountTypes {
    GET_ACCOUNT_INFO = 'GET_ACCOUNT_INFO',
    GET_ACCOUNT_INFO_COMPLETE = 'GET_ACCOUNT_INFO_COMPLETE',
    GET_ACCOUNT_INFO_FAILED = 'GET_ACCOUNT_INFO_FAILED',

    GET_ONLINE_STATUS = 'GET_ONLINE_STATUS',
    GET_ONLINE_STATUS_COMPLETE = 'GET_ONLINE_STATUS_COMPLETE',
    GET_ONLINE_STATUS_FAILED = 'GET_ONLINE_STATUS_FAILED',
    SET_ONLINE_STATUS = 'SET_ONLINE_STATUS',

    GET_UNLINKED_PLATFORMS = 'GET_UNLINKED_PLATFORMS',
    GET_UNLINKED_PLATFORMS_COMPLETE = 'GET_UNLINKED_PLATFORMS_COMPLETE',
    GET_UNLINKED_PLATFORMS_FAILED = 'GET_UNLINKED_PLATFORMS_FAILED',

    START_UPLAY_LINK_PROCESS = 'START_UPLAY_LINK_PROCESS',
    START_UPLAY_LINK_PROCESS_COMPLETE = 'START_UPLAY_LINK_PROCESS_COMPLETE',
    START_UPLAY_LINK_PROCESS_FAILED = 'START_UPLAY_LINK_PROCESS_FAILED',

    REQUEST_SIGN_IN = 'REQUEST_SIGN_IN',
    REQUEST_SIGN_OUT = 'REQUEST_SIGN_OUT',

    SET_SSO = 'SET_SSO',
    FETCH_SSO = 'FETCH_SSO',
    FETCH_SSO_SUCCESSFUL = 'FETCH_SSO_SUCCESSFUL'
}

// @depreciated
export const TYPES = AccountTypes;

export interface AccountInfoPayload {
    accountInfo?: AccountInfo;
}

export interface AccountErrorPayload {
    error: any;
}

export interface OnlineStatusPayload {
    status: any;
}

export interface UnlinkedPlatformsPayload {
    unlinkedPlatforms: string[];
}

export interface LinkResponsePayload {
    linkResponse: LinkResponse;
}

export interface RequestSignInPayload {
    state?: string;
}

export interface SSOValuePayload {
    value: boolean;
}

export interface AccountAction {
    type: AccountTypes;
    payload?:
        | AccountInfoPayload
        | AccountErrorPayload
        | OnlineStatusPayload
        | UnlinkedPlatformsPayload
        | LinkResponsePayload
        | RequestSignInPayload
        | SSOValuePayload;
}

export default {
    // @depreciated
    TYPES,

    getAccountInfo: (): AccountAction => ({
        type: AccountTypes.GET_ACCOUNT_INFO
    }),

    getAccountInfoSuccess: (accountInfo: AccountInfo): AccountAction => ({
        type: AccountTypes.GET_ACCOUNT_INFO_COMPLETE,
        payload: {accountInfo}
    }),

    getAccountInfoFailed: (error: any): AccountAction => ({
        type: AccountTypes.GET_ACCOUNT_INFO_FAILED,
        payload: {error}
    }),

    getOnlineStatus: (): AccountAction => ({
        type: AccountTypes.GET_ONLINE_STATUS
    }),

    getOnlineStatusSuccess: (status: PresenceType): AccountAction => ({
        type: AccountTypes.GET_ONLINE_STATUS_COMPLETE,
        payload: {status}
    }),

    getOnlineStatusFailed: (error: any): AccountAction => ({
        type: AccountTypes.GET_ONLINE_STATUS_FAILED,
        payload: {error}
    }),

    setOnlineStatus: (status: PresenceType): AccountAction => ({
        type: AccountTypes.SET_ONLINE_STATUS,
        payload: {status}
    }),

    getUnlinkedPlatforms: (): AccountAction => ({
        type: AccountTypes.GET_UNLINKED_PLATFORMS
    }),

    getUnlinkedPlatformsSuccess: (unlinkedPlatforms: string[]): AccountAction => ({
        type: AccountTypes.GET_UNLINKED_PLATFORMS_COMPLETE,
        payload: {unlinkedPlatforms}
    }),

    getUnlinkedPlatformsFailed: (error: any): AccountAction => ({
        type: AccountTypes.GET_UNLINKED_PLATFORMS_FAILED,
        payload: {error}
    }),

    startUplayLinkProcess: (): AccountAction => ({
        type: AccountTypes.START_UPLAY_LINK_PROCESS
    }),

    startUplayLinkProcessComplete: (linkResponse: LinkResponse): AccountAction => ({
        type: AccountTypes.START_UPLAY_LINK_PROCESS_COMPLETE,
        payload: {linkResponse}
    }),

    startUplayLinkProcessFailed: (error: any): AccountAction => ({
        type: AccountTypes.START_UPLAY_LINK_PROCESS_FAILED,
        payload: {error}
    }),

    requestSignIn: (state: string | React.SyntheticEvent): AccountAction => ({
        type: AccountTypes.REQUEST_SIGN_IN,
        payload: typeof state === 'string' ? {state} : {}
    }),

    requestSignOut: (): AccountAction => ({
        type: AccountTypes.REQUEST_SIGN_OUT
    }),

    setSSO: (value: boolean): AccountAction => ({
        type: AccountTypes.SET_SSO,
        payload: {value}
    }),

    fetchSSO: (): AccountAction => ({
        type: AccountTypes.FETCH_SSO
    }),

    fetchSSOSuccessful: (value: boolean): AccountAction => ({
        type: AccountTypes.FETCH_SSO_SUCCESSFUL,
        payload: {value}
    })
};
